import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CityModel } from './city.model';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
     // 'Content-Type': 'application/json; charset=utf-8',
     // 'Authorization': "Bearer " + token,
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Cities/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

getAllByCountryId(CountryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Cities/GetAllByCountryId/${CountryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}City/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: CityModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Cities/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

update(payload: CityModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Cities/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}Cities/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

  deleteList(payload: CityModel []): Observable<any> {
    console.log(JSON.stringify(payload))
    return this.http
      .post<any>(`${this.baseUrl}Cities/DeleteList`,JSON.stringify(payload),this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }
}
